import { render, staticRenderFns } from "./DesktopNav.vue?vue&type=template&id=3f3ec241&scoped=true&"
import script from "./DesktopNav.vue?vue&type=script&lang=js&"
export * from "./DesktopNav.vue?vue&type=script&lang=js&"
import style0 from "./DesktopNav.vue?vue&type=style&index=0&id=3f3ec241&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3ec241",
  null
  
)

export default component.exports